
import React, { Component } from "react";
import { Modal } from "antd";
import CloseIcon from "../../../assets/fi_x-circle.svg";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { setkeyboardEnabled } from "../../../actions/AppAction";
import { sendShareAssets } from "../../../actions/AssetsShareAction";
import { getNewPermission, sendNotification } from '../../../utils/index';
import { editFolder } from '../../../actions/ClientAction';
import { cleanDataBackRoot, getRoot } from '../../../actions/AssetsRootAction';
import { getExplore } from '../../../actions/AssetsExploreAction'
import "./GroupModal.css";
import { Tabs, Spin } from 'antd'
import Permission from "../../permission/Permission";
import { showPermission, getOnlyPermissions, hidePermission } from "../../../actions/PermissionAction";
import { getGroupByClient } from "../../../actions/GroupAction";
import List from "../../groups/List";
import Create from "../../groups/Create";
import { getPlanServicesByUser } from "../../../actions/PlanServicesAction";
import _ from "lodash";


const { TabPane } = Tabs

class GroupModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showCreateGroup: false,
      showAllGroup: false,
      disableControls: false,
      assetType: '',
      thisAsset: ''
    }
  }

  componentDidMount() {
    const { authUser, workclient } = this.props
    this.setState({
      disableControls: (authUser.role === 'admin' || authUser.clientRole === 'admin') ? false : true,
      showAllGroup: true,
      showCreateGroup: true
    }, () => {
      this.props.getGroupByClient(workclient);
      this.props.getPlanServicesByUser(workclient);
    })
  }
  
  componentDidUpdate(prevProps) {
    const { groupsByClient, isFetching } = this.props
    if (prevProps.isFetching !== isFetching && prevProps.groupsByClient !== groupsByClient) {
      // this.setState({ showAllGroup: true }) WTF!
    }
  }

  handleNewNameChanged = e => {
    this.setState({
      newName: e.target.value
    });
  };

  handleOnEdit = () => {
    const {
      workclient,
      selectedFile,
      user,
      newMatrix,
      intl
    } = this.props;

    const {
      newName
    } = this.state;

    const canEditFolder = (user.clientRole !== 'admin' && user.role !== 'admin') ? getNewPermission(selectedFile._id, newMatrix, 'editFolder') : true;

    if(!canEditFolder){
      sendNotification('warning', intl, intl.formatMessage({ id: 'permission_denied' }));
      return;
    }
    if(newName.length === 0){
      sendNotification('warning', intl, intl.formatMessage({ id: 'move-modal-empty' }));
      return;
    }

    this.props.editFolder(workclient, selectedFile._id, newName, null, null, undefined, undefined, this.handleOnHideModal)
  }

  handleOnHideModal = () => {
    const {intl, workclient, root } = this.props;
    sendNotification('success', intl, intl.formatMessage({ id: 'move-modal-success' }));
    const location = this.props.history.location.pathname;
    if(!location.includes("explore")){
      this.props.cleanDataBackRoot()
      // this.props.getRoot(workclient, root)
      this.props.getRoot(workclient, root, true, [], 1, 40)
      this.props.handleHiddenModal();
      return;
    }
    const folderId = location.split("/").pop();
    if(!folderId) return;
    this.props.handleHiddenModal();
    this.props.getExplore(workclient, folderId, 1, null, true, [], 40);
  }

  render() {
    const {
      showModal,
      handleHiddenModal,
      intl,
      isFetchingObjectGroups,
      permissionShow,
      groupsByClient,
      clientName,
      item,
      userServices,
    } = this.props;
    const { showCreateGroup, disableControls, showAllGroup } = this.state
    const results = userServices && userServices.find(({ idService }) => idService === "6424ad7089441071d65b7b27");
    const hireds = _.isNil(results);
    const groupsTop = groupsByClient && groupsByClient.length;
    const contractedGroups = 3
    return (
      <Modal
        visible={showModal}
        onCancel={handleHiddenModal}
        width={'80%'}
        footer={null}
        centered
        closeIcon={<img src={CloseIcon} alt={"icon close"} />}
        className="move-modal"
      >
        <div
          className="move-modal-title"
        >
          {intl.formatMessage({ id: "groups" })}
        </div>

        <Tabs defaultActiveKey="1" tabPosition="top">
          <TabPane tab="General" key="1">
            {isFetchingObjectGroups &&
            <div
              style={{
                display: "flex",
                "width": "100%",
                "height": "50vh",
                "justifyContent": "center",
                "alignItems": "center"
              }}>
              <Spin size="large"/>
            </div>
            }
            {!isFetchingObjectGroups && permissionShow && <Permission/>}
          </TabPane>
          {!disableControls && 
            <TabPane 
              visible={disableControls} 
              tab={intl.formatMessage({ id: "all_the_groups" })}
              key="2"
              disabled={disableControls}>
              <div style={{marginBottom: 10}}>
                {intl.formatMessage({ id: "all_the_groups" })} {intl.locale === 'es' ? 'en' : 'in'}: {clientName.name}
              </div>
              {showAllGroup && <List
                from={`Permissions-showallGroup`}
                data={groupsByClient}
                isRemovable={true}
                isSelectable={true}
                dataSelected={item && item.group}
                handleClose={this.handleHideAllGroup}
                allTheGroups={true} />} 
            </TabPane>}
          {!disableControls && (!hireds || groupsTop < contractedGroups ) &&
            <TabPane tab={intl.formatMessage({ id: "new_group_button" })} key="3" disabled={disableControls}>
              {showCreateGroup && <Create handleClose={this.handleHideCreateGroup} />}
          </TabPane>}
          
        </Tabs>

      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    selectedFile: state.individualSelect.selectedFile,
    workclient: state.client.data ? state.client.data._id : null,
    isInFolderAction: state.client.isInFolderAction,
    user: state.authUser.user,
    newMatrix: state.group.newMatrix,
    root: state.client.root,
    limit: state.assetsExplore.limit,
    permissionShow: state.permission.showModal,
    isFetchingObjectGroups: state.permission.isFetchingObjectGroupsModal,
    authUser: state.authUser.user,
    item: state.permission.item,
    newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
    isFetching: state.group.byClientIsFetching,
    groupsByClient: state.group.byClientData,
    clientName: state.client.data,
    userServices: state.planServices.userServices
  };
};

const mapDispatchToProps = {
  setkeyboardEnabled,
  sendShareAssets,
  editFolder,
  getRoot,
  cleanDataBackRoot,
  getExplore,
  showPermission,
  hidePermission,
  getOnlyPermissions,
  getGroupByClient,
  getPlanServicesByUser,
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(GroupModal))
);
